// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

// To get bootstrap modals etc working jQuery needs to be loaded before bootstrap
import "@hotwired/turbo-rails"

import "./src/jquery"
import "./src/bootstrap"
import "./src/all-common"
import "./controllers"

import "./src/select2.full.min"



// import "./src/jquery.mjs.nestedSortable"

// console.log($)

// $('#system_modal_popup').on('hidden.bs.modal', function(e) {
//   $('#system_modal').html('');
// })